export default __webpack_public_path__ + "images/0b3ce4b7f8a566f54875c93bb12363ef.svg";